package info.rezident.app.ui.theme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

@Composable
fun AppTheme(
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
) {
    val isDarkMode = ColorMode.current.isDark
    val appColors = if (isDarkMode) {
        darkPalette
    } else {
        lightPalette
    }

    CompositionLocalProvider(
        LocalAppColors provides appColors,
        LocalAppShapes provides appShapes,
        LocalAppTypography provides AppTypography
    ) {
        Surface(modifier) {
            content()
        }
    }
}

object AppTheme {
    @get:Composable
    val colors: AppColors
        get() = LocalAppColors.current

    @get:Composable
    val shapes: AppShapes
        get() = LocalAppShapes.current

    @get:Composable
    val typography: AppTypography
        get() = LocalAppTypography.current
}

@InitSilk
fun initSilkTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.light.background = Color.rgb(0xFCFCFC)
    ctx.theme.palettes.light.color = Colors.Black
    ctx.theme.palettes.dark.background = Color.rgb(0x121212)
    ctx.theme.palettes.dark.color = Colors.White
}
